import * as types from './types';

const getCollaboratorsInfo = postingId => {
  return {
    type: types.FETCH_COLLABORATORS_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/getUsersWithPermissions`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const getPostingInfo = postingId => {
  return {
    type: types.GET_POSTING_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postings/getpostinginfo`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const updateUserPermissions = (postingId, userId, grant, userName) => ({
  type: types.UPDATE_USER_PERMISSIONS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v2/postings/updateUserPermissions`,
    method: 'PUT',
    query: { postingId, userId, grant },
    userName
  }
});

export { getCollaboratorsInfo, getPostingInfo, updateUserPermissions };
